<template>
  <div class="enrolling-intend-city"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <div class="distribute-cont"
         v-loading="committing"
         element-loading-text="数据提交中，请稍等...">
      <el-transfer v-model="enableIntendCityIds"
                   :data="intendCityList"
                   filterable
                   :titles="['可选意向城市', '已选意向城市']"
                   :props="defaultProps">
      </el-transfer>
    </div>
    <div class="footer">
      <el-button size="mini"
                 type="primary"
                 :disabled="committing"
                 @click="saveIntendCity">提交设置</el-button>
      <el-button size="mini"
                 type="default"
                 @click="handleClose">取消操作</el-button>
  </div>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../elements/AppScrollbar'
export default {
  name: 'EnrollingIntendCity',
  components: {
    AppScrollbar
  },
  props: {
    rowData: Object
  },
  data () {
    return {
      loading: false,
      originCityIds: [],
      intendCityList: [],
      enableIntendCityIds: [],
      defaultProps: {
        key: 'id',
        label: 'name'
      },
      committing: false
    }
  },
  methods: {
    loadIntendCity () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/admission/amount/querySiteIntendCity',
        method: 'post',
        data: this.$qs.stringify({
          batchSiteId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              let enableIntendCityStr = response.data['enableIntendCity'] || ''
              this.originCityIds = enableIntendCityStr === '' ? [] : enableIntendCityStr.split(',')
              this.intendCityList = response.data['intendCityList'] || []
              this.enableIntendCityIds = this.originCityIds.concat()
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    saveIntendCity () {
      let enableIntendCityIds = this.enableIntendCityIds || []
      let originCityIds = this.originCityIds || []
      let addEnableIntendCityIds = []
      let delEnableIntendCityIds = []
      enableIntendCityIds.forEach(id => {
        if (!originCityIds.includes(id)) {
          addEnableIntendCityIds.push(id)
        }
      })
      originCityIds.forEach(id => {
        if (!enableIntendCityIds.includes(id)) {
          delEnableIntendCityIds.push(id)
        }
      })
      if (addEnableIntendCityIds.length === 0 && delEnableIntendCityIds.length === 0) {
        this.$message.warning('配置未发生变化')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/enrolling/admission/amount/setSiteEnableIntendCity',
        method: 'post',
        data: this.$qs.stringify({
          batchSiteId: this.rowData.id,
          enableIntendCity: this.enableIntendCityIds.join(',')
        }, {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.$nextTick(() => {
                this.originCityIds = enableIntendCityIds.concat()
                this.$emit('hidePopoverAndRefresh')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    this.loadIntendCity()
  }
}
</script>

<style lang="scss">
.enrolling-intend-city {
  .distribute-cont {
    height: 100%;
    padding: 15px;
    box-sizing: border-box;
    .el-transfer {
      display: flex;
      align-items: center;
      font-size: 12px;
      & > .el-transfer-panel {
        flex: 0 1 50%;
        width: auto;
        border-radius: 0;
        .el-transfer-panel__header {
          .el-checkbox {
            .el-checkbox__label {
              font-size: 13px;
            }
          }
        }
        .el-transfer-panel__body {
          height: 380px;
          .el-transfer-panel__list {
            height: 420px;
            &.is-filterable {
              height: 373px;
            }
          }
          .el-checkbox {
            .el-checkbox__label {
              font-size: 12px;
            }
          }
        }
      }
      & > .el-transfer__buttons {
        padding-left: 10px;
        padding-right: 10px;
        white-space: nowrap;
        .el-button {
          padding: 4px;
        }
      }
    }
  }
  & > .footer {
    height: 52px;
    background-color: #fff;
    border-top: 1px solid rgba(0,0,0,.05);
    text-align: center;
    line-height: 50px;
  }
}
</style>
